/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/kendo-ui/kendo-ui.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type EurovisionSelectDirectiveCb = ($timeout: ng.ITimeoutService) => EurovisionSelectDirective;

    /**
     * Custom scope
     */
    export interface IEurovisionSelectDirectiveScopeDef {
        id: string;
        options: string;
        model: string;
        text: string;
        value: string;
        enabled: string;
        parsleyAtleast: string;
        width: string;
        required: string;
        backgroundColor: string;
        textColor: string;
        onChange: string;
        comparator: string;
    }

    export interface IEurovisionSelectDirectiveScope extends ng.IScope {
        id: string;
        options: string[] | number[] | Object[];
        model: string | number | Object;
        text: string;
        value: string;
        enabled: boolean;
        parsleyAtleast: string;
        width: string;
        required: boolean;
        backgroundColor: string;
        textColor: string;
        onChange: (args: Object) => void;
        comparator: (elements: Object) => boolean;

        selectObject: kendo.ui.DropDownList;
    }
    
    export class EurovisionSelectDirective implements ng.IDirective {
        public static $name: string = "eurovisionSelect";
        public static $inject: string[] = ['$timeout'];

        public restrict: string = 'E';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/eurovision-select-directive.html';
        public link: (scope: IEurovisionSelectDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public scope: IEurovisionSelectDirectiveScopeDef = {
            id: '@',
            options: '=',
            model: '=',
            text: '@',
            value: '@',
            enabled: '=',
            parsleyAtleast: '@',
            width: '@',
            required: '@?',
            backgroundColor: '@?',
            textColor: '@?',
            onChange: '&?',
            comparator: '&?',
        };

        public static Factory(): EurovisionSelectDirectiveCb {
            let directive: EurovisionSelectDirectiveCb = ($timeout: ng.ITimeoutService) => {
                return new EurovisionSelectDirective($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }

        constructor($timeout: ng.ITimeoutService) {
            EurovisionSelectDirective.prototype.link = (scope: IEurovisionSelectDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                if (!scope.required) {
                    scope.required = false;
                }

                if (!scope.comparator) {
                    scope.comparator = this.defaultModelComparator;
                }

                this.setWidth(scope);
                scope.selectObject = this.getSelectObject(scope, $timeout);

                scope.$watch('options', (newValue: Object) => {
                    if (newValue !== undefined) {
                        if (scope.selectObject === undefined) {
                            scope.selectObject = this.getSelectObject(scope, $timeout);
                        }
                        let options: kendo.data.DataSource = new kendo.data.DataSource({
                            data: newValue,
                        });
                        scope.selectObject.setDataSource(options);
                        scope.selectObject.select(this.getModelIndex(scope));
                    }
                }, true);

                scope.$watch('model', (newValue: Object) => {
                    if (newValue !== undefined) {
                        scope.selectObject.select(this.getModelIndex(scope));
                    } else {
                        scope.selectObject.select(-1);
                    }
                }, true);

                scope.$watch('enabled', (newValue: boolean) => {
                    if (newValue !== undefined) {
                        scope.selectObject.enable(newValue);
                    }
                });

                scope.$watch('backgroundColor', (newValue: string) => {
                    if ($("#" + scope.id + ' select') !== undefined) {
                        if (scope.backgroundColor) {
                            $('span[aria-owns="' + scope.id + '_listbox"] .k-dropdown-wrap').css('background-color', newValue);
                        }
                    }
                });

                scope.$watch('textColor', (newValue: string) => {
                    if ($("#" + scope.id + ' select') !== undefined) {
                        if (scope.textColor) {
                            $('span[aria-owns="' + scope.id + '_listbox"] .k-input').css('color', newValue)
                                                                                    .css('text-shadow', '1px 1px 3px #000');
                        }
                    }
                });

                scope.$on('$destroy', () => {
                    if (scope.selectObject !== undefined)
                        scope.selectObject.destroy();
                });
            };
        }

        private getSelectObject(scope: IEurovisionSelectDirectiveScope, $timeout: angular.ITimeoutService): kendo.ui.DropDownList {
            let element: JQuery = $("#" + scope.id);
            if (element !== undefined) {
                const kendoDropDownList: JQuery = element.kendoDropDownList({
                    dataTextField: scope.text,
                    dataValueField: scope.value,
                    change: (e: kendo.ui.DropDownListChangeEvent) => {
                        this.changeModel(e, scope);
                        if (scope.onChange) {
                            scope.onChange({newValue: e.sender.value()});
                        }
                    },
                    select: function (e: kendo.ui.DropDownListSelectEvent): void {
                        $timeout(() => {
                            scope.model = scope.value ? scope.options[(e.item.index())][scope.value] : scope.options[(e.item.index())];
                            if (scope.required) {
                                // if we have required validation with parsley, we generate an option inside the select tag
                                if ($("#" + scope.id + ' select') !== undefined) {
                                    $("#" + scope.id + ' select').html(e.item.text() ?
                                        '<option selected value=" + e.item.text() + "></option>' : '');
                                }
                            }
                        });
                    },
                });
                const selectObject: kendo.ui.DropDownList = kendoDropDownList.data("kendoDropDownList");
                return scope.selectObject = selectObject;
            } else {
                return undefined;
            }
        }

        private setWidth(scope: IEurovisionSelectDirectiveScope): void {
            if (scope.width !== undefined && $("#" + scope.id) !== undefined)
                $("#" + scope.id).css('width', scope.width);
        }

        private getModelIndex(scope: IEurovisionSelectDirectiveScope): number {
            let indexResult: number = -1;
            if (scope.options) {
                for (let i: number = 0; i < scope.options.length; i++) {
                    if (scope.value !== undefined && scope.comparator({
                            firstElement: scope.options[i][scope.value],  secondElement:scope.model}) ||
                        scope.value === undefined && scope.comparator({
                            firstElement:scope.options[i], secondElement:scope.model})) {
                        indexResult = i;
                    }
                }
            }
            return indexResult;
        }

        private defaultModelComparator(elements:any): boolean {
            return angular.equals(elements.firstElement, elements.secondElement);
        }

        private changeModel(e: kendo.ui.DropDownListChangeEvent, scope: IEurovisionSelectDirectiveScope): void {
            if (scope.options && typeof scope.options[0] === "object") {
                this.changeModelForObjectArray(e, scope);
            } else if (scope.options && typeof scope.options[0] === "string") {
                this.changeModelForArray(e, scope);
            } else if (scope.options && typeof scope.options[0] === "number") {
                this.changeModelForArray(e, scope);
            }
        }

        private changeModelForObjectArray(e: kendo.ui.DropDownListChangeEvent, scope: IEurovisionSelectDirectiveScope): void {
            const id: number = e.sender.value() ? e.sender.value()['id'] : undefined;
            if (id) {
                for (const opt of scope.options) {
                    if (opt['id'] && opt['id'] == id) {
                        scope.model = opt;
                        break;
                    } 
                }
            }
        }

        private changeModelForArray(e: kendo.ui.DropDownListChangeEvent, scope: IEurovisionSelectDirectiveScope): void {
            for (const opt of scope.options) {
                if (opt == e.sender.value()) {
                    scope.model = opt;
                    break;
                }
            }
        }
    }
}